// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';

export async function getRoutes() {
  const routes = {"1":{"path":"/login","name":"login","icon":"smile","hideInMenu":true,"parentId":"ant-design-pro-layout","id":"1"},"2":{"path":"/team","name":"团队管理","icon":"user","parentId":"ant-design-pro-layout","id":"2"},"3":{"path":"/team/agent","name":"代理商管理","icon":"smile","parentId":"2","id":"3"},"4":{"path":"/equipment","name":"设备管理","icon":"crown","parentId":"ant-design-pro-layout","id":"4"},"5":{"path":"/equipment/cabinet","name":"机柜管理","icon":"smile","parentId":"4","id":"5"},"6":{"path":"/equipment/powerBank","name":"充电宝管理","icon":"smile","parentId":"4","id":"6"},"7":{"path":"/","redirect":"/login","parentId":"ant-design-pro-layout","id":"7"},"8":{"path":"*","layout":false,"id":"8"},"ant-design-pro-layout":{"id":"ant-design-pro-layout","path":"/","isLayout":true}} as const;
  return {
    routes,
    routeComponents: {
'1': React.lazy(() => import(/* webpackChunkName: "p__Welcome" */'@/pages/Welcome.tsx')),
'2': React.lazy(() => import('./EmptyRoute')),
'3': React.lazy(() => import(/* webpackChunkName: "p__team__agent__index" */'@/pages/team/agent/index.tsx')),
'4': React.lazy(() => import('./EmptyRoute')),
'5': React.lazy(() => import(/* webpackChunkName: "p__equipment__cabinet__index" */'@/pages/equipment/cabinet/index.tsx')),
'6': React.lazy(() => import(/* webpackChunkName: "p__equipment__powerBank__index" */'@/pages/equipment/powerBank/index.tsx')),
'7': React.lazy(() => import('./EmptyRoute')),
'8': React.lazy(() => import(/* webpackChunkName: "p__404" */'@/pages/404.tsx')),
'ant-design-pro-layout': React.lazy(() => import(/* webpackChunkName: "t__plugin-layout__Layout" */'/home/jenkins/agent/workspace/web-release/src/.umi-production/plugin-layout/Layout.tsx')),
},
  };
}
